export enum ListType
{
  None = -1,
  Account = 0,
  Client = 1,
  ClientParent = 2,
  Creditor = 3,
  Debtor = 4,
  Estate = 5,
  HeadLease = 6,
  Landlord = 7,
  Lease = 8,
  Manager = 9,
  Property = 10,
  Supplier = 11,
  Tenant = 12,
  Unit = 13,
  Vacant = 14,
  TenantParent = 15,
  NotificationRequest = 16,
  Notification = 17,
  MbeAgedDebtGlTransaction = 18,
  DebtorAccountHistory = 19,
  CallWorkItem = 20,
  InvoicesAndReceipts = 21,
  MciManageMyUsers = 22,
  MfsManageMyUsers = 23,
  MftManageMyUsers = 24
}
